import { motion } from "framer-motion";
import {
  FaFingerprint,
  FaHeadset,
  FaNetworkWired,
  FaProjectDiagram,
  FaShieldAlt,
  FaTools,
  FaUserShield,
  FaVideo,
} from "react-icons/fa";

import { HiArrowRight } from "react-icons/hi";
import { Link } from 'react-router-dom';
import bricks from "../assets/bricks.jpg";
import abt from '../assets/ict1.webp';
import whyImg from "../assets/ict3.jpg";
import { default as bgImage, default as firebg } from "../assets/ictbg.jpg";
import sand from "../assets/sand.jpg";
import steel from "../assets/steel2.jpg";


const categories = [
  {
    id: 1,
    title: "Network & Infrastructure",
    description:
      "Design and installation of structured cabling, LAN/WAN networks, fiber optics, and reliable connectivity solutions.",
    icon: <FaNetworkWired className="text-white text-3xl" />,
    bgColor: "bg-primary",
  },
  {
    id: 2,
    title: "CCTV Surveillance",
    description:
      "Professional installation of IP and analog CCTV systems with remote monitoring and secure video recording.",
    icon: <FaVideo className="text-white text-3xl" />,
    bgColor: "bg-secondary",
  },
  {
    id: 3,
    title: "Access Control Systems",
    description:
      "Biometric, card, and smart access control solutions to manage and monitor entry points securely.",
    icon: <FaFingerprint className="text-white text-3xl" />,
    bgColor: "bg-primary",
  },
  {
    id: 4,
    title: "Cyber & System Security",
    description:
      "Firewall setup, network protection, and system security solutions to safeguard data and digital assets.",
    icon: <FaShieldAlt className="text-white text-3xl" />,
    bgColor: "bg-secondary",
  },
];

const reasons = [
  {
    id: 1,
    title: "Certified & Skilled Professionals",
    description:
      "Our team consists of experienced ICT and security specialists trained to deliver reliable and compliant solutions.",
    icon: <FaUserShield className="text-gray-800 text-3xl" />,
  },
  {
    id: 2,
    title: "End-to-End Solutions",
    description:
      "We handle everything from system design and installation to testing, training, and ongoing support.",
    icon: <FaProjectDiagram className="text-gray-800 text-3xl" />,
  },
  {
    id: 3,
    title: "Modern & Secure Technology",
    description:
      "We deploy up-to-date ICT infrastructure and advanced security systems to protect your assets and data.",
    icon: <FaTools className="text-gray-800 text-3xl" />,
  },
  {
    id: 4,
    title: "Reliable Support & Maintenance",
    description:
      "We provide responsive technical support and preventive maintenance to ensure continuous system performance.",
    icon: <FaHeadset className="text-gray-800 text-3xl" />,
  },
];

const materials = [
  {
    id: 2,
    name: "Bricks",
    image: bricks,
  },
  {
    id: 3,
    name: "Steel Rods",
    image: steel,
  },
  {
    id: 4,
    name: "Sand",
    image: sand,
  },
];

function MaterialSupply() {
  return (
    <div>
      <section
        className="relative w-full h-[30vh] md:h-[40vh] bg-cover bg-center"
        style={{ backgroundImage: `url(${firebg})` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-75"></div>
        <div className="relative z-10 flex flex-col items-start justify-center h-full px-6 md:px-12 max-w-6xl mx-auto text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">ICT & Security services</h1>
          <div className="flex items-center text-sm md:text-base space-x-2 text-gray-200">
            <Link to="/" className="hover:text-white cursor-pointer">Home</Link>
            <span>/</span>
            <span className="text-gray-300 underline hover:text-white cursor-pointer"> ICT service</span>
          </div>
        </div>
      </section>

      <section className="w-full py-16 bg-white">
        <div className="mx-auto max-w-6xl flex flex-col md:flex-row items-stretch gap-10 px-6">
          {/* Image */}
          <motion.img
            src={abt}
            alt="ict"
            loading="lazy"
            className="w-full md:w-1/2 h-[60vh]  object-cover rounded-lg shadow-lg"
            initial={{ x: -100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
          />

          {/* Content */}
          <motion.div
            className="flex flex-col justify-center gap-6 md:w-1/2 h-full"
            initial={{ x: 100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800">
              ICT & Security Solutions
            </h2>

            <p className="text-gray-600 text-base md:text-lg leading-relaxed">
              We provide comprehensive ICT and security solutions designed to protect people,
              assets, and information while ensuring reliable connectivity and system efficiency.
              Our services cover network infrastructure, surveillance systems, access control,
              and integrated smart security solutions for modern facilities.
            </p>

            {/* Highlighted Statement */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="bg-primary/10 border-l-4 mt-10 border-primary text-gray-800 text-base md:text-lg font-medium p-4 rounded-md"
            >
              <p>
                “Secure, connected, and intelligent systems — built to support today’s
                operations and tomorrow’s growth.”
              </p>
            </motion.div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 mt-4">
              <motion.a
                href="/contact"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="inline-flex items-center justify-center gap-3 px-6 py-3 bg-primary text-black font-medium rounded-md transition-all w-full sm:w-auto"
              >
                Contact Us
                <span className="bg-white p-2 rounded-full flex items-center justify-center">
                  <HiArrowRight className="w-5 h-5 text-black" />
                </span>
              </motion.a>

              <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                <Link
                  to="/quote"
                  className="inline-flex items-center justify-center gap-3 px-6 py-3 bg-secondary text-primary font-medium rounded-md transition-all w-full sm:w-auto"
                >
                  Ruest Quote
                  <span className="bg-white p-2 rounded-full flex items-center justify-center">
                    <HiArrowRight className="w-5 h-5 text-black" />
                  </span>
                </Link>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">
            Our ICT & Security Solutions
          </h2>

          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {categories.map((category, index) => (
              <motion.div
                key={category.id}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
                className="relative bg-white shadow-lg rounded-xl p-6 pt-16 flex flex-col items-center text-center"
              >
                {/* Icon centered at the top border */}
                <div
                  className={`absolute -top-8 left-1/2 transform -translate-x-1/2 w-20 h-20 rounded-full flex items-center justify-center ${category.bgColor}`}
                >
                  {category.icon}
                </div>

                {/* Title */}
                <h3 className="text-xl font-semibold mt-4">{category.title}</h3>

                {/* Description */}
                <p className="text-gray-600 mt-2">{category.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 flex flex-col lg:flex-row items-center gap-12">
          {/* Left side: Text + Cards */}
          <div className="w-full lg:w-1/2">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="text-3xl font-bold text-gray-800 mb-10 text-center lg:text-left"
            >
              Why Choose Our ICT  Solutions

            </motion.h2>

            <div className="grid gap-8 sm:grid-cols-2">
              {reasons.map((item, index) => (
                <motion.div
                  key={item.id}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.2 }}
                  className="p-6 bg-white rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 flex flex-col items-center text-center border border-gray-100"
                >
                  <div className="w-20 h-20 flex items-center justify-center border-2 border-gray-800 rounded-full mb-3">
                    {item.icon}
                  </div>
                  <h3 className="text-lg font-semibold text-gray-800 mb-3">
                    {item.title}
                  </h3>
                  {/* <p className="text-gray-600 text-sm">{item.description}</p> */}
                </motion.div>
              ))}
            </div>
          </div>

          {/* Right side: Image */}
          <motion.div
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            className="w-full lg:w-1/2 h-[60vh]"
          >
            <img
              src={whyImg}
              loading="lazy"
              alt="Why Choose Us"
              className="rounded-2xl shadow-lg w-full h-full object-cover"
            />
          </motion.div>
        </div>
      </section>

      {/* <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4">
          
          <div className="flex flex-col sm:flex-row justify-between items-center mb-10">
            <h2 className="text-3xl font-bold text-gray-800 mb-4 sm:mb-0">
              Some of Our Building Materials
            </h2>
            <Link
              to="/products"
              className="bg-gray-900 hover:bg-gray-800 text-white font-semibold px-6 py-3 rounded-lg transition-all duration-300"
            >
              More Materials
            </Link>
          </div>

          
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {materials.slice(0, 4).map((item, index) => (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
                className="relative overflow-hidden rounded-md shadow-md group cursor-pointer"
              >
                
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-[400px] object-cover transform group-hover:scale-105 transition-transform duration-500"
                />

                
                <div className="absolute inset-0 bg-black bg-opacity-20 group-hover:bg-opacity-50 transition-all duration-500"></div>

                
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500">
                  <div className="border-2 border-primary w-[90%] h-[85%] flex items-center justify-center text-white text-xl font-semibold bg-black bg-opacity-30 rounded-md backdrop-blur-sm">
                    {item.name}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section> */}

      <section
        className="relative py-16 mb-16 bg-cover bg-center bg-fixed"
        style={{
          backgroundImage: `url(${bgImage})`,
        }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>

        {/* Content */}
        <div className="relative z-10 max-w-5xl mx-auto text-center px-4">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-3xl md:text-4xl font-bold text-white mb-6"
          >
            Need Reliable ICT & Security Solutions?
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-gray-200 text-base md:text-lg mb-8 max-w-3xl mx-auto"
          >
            we deliver dependable ICT and security solutions tailored
            to your business and facility needs.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <Link
              to="/quote"
              className="inline-block bg-primary  text-secondary font-semibold px-10 py-4 rounded-lg shadow-lg transition-all duration-300"
            >
              Get a Quote
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  )
}

export default MaterialSupply
